var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWhiteAddAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16675 4.49984H10.3334C11.2175 4.49984 12.0653 4.85103 12.6904 5.47615C13.3156 6.10127 13.6667 6.94912 13.6667 7.83317C13.6667 8.71723 13.3156 9.56507 12.6904 10.1902C12.0653 10.8153 11.2175 11.1665 10.3334 11.1665H9.50008M4.50008 7.83317L1.16675 4.49984L4.50008 1.1665V7.83317Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhiteAddAccount);
export default __webpack_public_path__ + "static/media/arrow-white-add-account.0dcc880b587d48ac86000d7d8837edff.svg";
export { ForwardRef as ReactComponent };